import '../../assets/scss/App.scss';
import NovyLayout from './NovyLayout';
import NovyLoading from './NovyLoading';
import NovyBreadcrumbs from './NovyBreadcrumbs';

export {NovyLoading,NovyBreadcrumbs};
export default  NovyLayout;

